<template>
  <div class="flex flex-col w-full justify-start items-center px-2">
    <span>Connection:</span>
    <div class="flex flex-col w-full">
      <div class="flex flex-row bg-gray-200 rounded-md h-8 justify-center items-center">
        <select class="w-3/4 h-6 text-xs mr-1 border-grey-500 rounded-md border-2"
          :disabled="disabled"
          v-model="formValues">
          <option v-for="userConnection in userConnectionOptions"
            :key="userConnection"
            :value="userConnection">
            {{ userConnection }}
          </option>
        </select>
        <XButton class="bg-orange-200 p-1 w-4 h-4"
          @click="deleteGroup"
        />
      </div>
    </div>
  </div>
</template>

<script>
import XButton from '../XButton.vue'

export default {
  components: {
    XButton
  },
  props: {
    userConnectionOptions: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    value: undefined,
    defaultValue: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      formValues: undefined,
    }
  },
  mounted() {
    if (this.defaultValue !== undefined) {
      this.formValues = this.defaultValue
    }
  },
  methods: {
    updateValue() {
      this.$emit('input', this.formValues)
    },
    deleteGroup() {
      this.formValues = undefined
    }
  },
  watch: {
    value(newValue) {
      this.formValues = newValue
    },
    formValues() {
      this.updateValue()
    },
    defaultValue(newValue) {
      this.formValues = newValue
    }
  }
}
</script>
